import React, { useState, useEffect } from "react";
import { Table, Button, Input, Form, Modal, Card, InputNumber } from "antd";
import api from "../../api";
import { EditOutlined } from "@ant-design/icons";

const GalleryPage = () => {
  const [images, setImages] = useState([]);
  const [editingImage, setEditingImage] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  useEffect(() => {
    fetchImages();
  }, [pagination.current, pagination.pageSize, search]);

  const fetchImages = async () => {
    setLoading(true);
    try {
      const response = await api.get("/panel/gallery", {
        params: {
          page: pagination.current,
          per_page: pagination.pageSize,
          search,
        },
      });
      setImages(response.data.data);
      setPagination({
        current: response.data.meta.current_page,
        pageSize: response.data.meta.per_page,
        total: response.data.meta.total,
      });
    } catch (error) {
      console.error("خطا در دریافت تصاویر:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };

  const showEditModal = (image) => {
    setEditingImage(image);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingImage(null);
  };

  const handleSave = async (values) => {
    try {
      await api.put(`/panel/gallery/${editingImage.id}?_method=PUT`, {
        name: values.name,
        alt: values.alt,
        order: values.order,
      });
      fetchImages();
      setIsModalVisible(false);
      setEditingImage(null);
    } catch (error) {
      console.error("خطا در بروزرسانی تصویر:", error);
    }
  };

  const columns = [
    {
      title: "شناسه",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "تصویر",
      dataIndex: "url",
      key: "image",
      render: (url) => (
        <img
          src={url}
          alt="تصویر"
          style={{
            width: 150,
            height: 100,
            objectFit: "cover",
            borderRadius: 5,
          }}
        />
      ),
    },
    {
      title: "نوع",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "اندازه",
      dataIndex: "size",
      key: "size",
    },
    {
      title: "عملیات",
      key: "actions",
      render: (_, record) => (
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() => showEditModal(record)}
        ></Button>
      ),
    },
  ];

  return (
    <Card>
      <h1 className="text-2xl font-bold mb-5">گالری </h1>

      <Table
        dataSource={images}
        columns={columns}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          showTotal: (total) => `مجموع: ${total} تصویر`,
        }}
        onChange={handleTableChange}
        rowKey="id"
      />
      <Modal
        title="ویرایش تصویر"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        {editingImage && (
          <Form
            initialValues={{
              name: editingImage.name,
              alt: editingImage.alt,
            }}
            onFinish={handleSave}
          >
            <Form.Item
              label="نام"
              name="name"
              rules={[{ required: true, message: "لطفاً نام را وارد کنید!" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label=" alt"
              name="alt"
              rules={[
                { required: true, message: "لطفاً متن جایگزین را وارد کنید!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label=" order"
              name="order"
              rules={[
                { required: true, message: "لطفاً  ترتیب را وارد کنید!" },
              ]}
            >
              <InputNumber />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                ذخیره
              </Button>
            </Form.Item>
          </Form>
        )}
      </Modal>
    </Card>
  );
};

export default GalleryPage;
